
import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { DialogBtnConfig } from "./index";

@Component({})
export default class H5ReportDialog extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) content!: string;
  @Prop({ type: Array, default: () => [] }) buttons!: DialogBtnConfig[];

  @Emit("update:show")
  handleUpdateShow(val: boolean) {
    return val;
  }

  @Emit("click-btn")
  handleClickBtn(index: number) {
    return index;
  }
}
